'use client'; // Error boundaries must be Client Components
import Header from '@/components/Header';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { type } from 'node:os';

const Error = ({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) => {
	const t = useTranslations('NotFound');
	return (
		<>
			<Header locale={'es'} theme={'light'} referrer={'/'}  />
			<main className="page-container flex flex-col items-center justify-center">
				<div className="leading-30 md:leading-60 flex items-center justify-center text-[128px] font-bold md:text-[256px]">
					5
					<Image
						width={260}
						height={260}
						className="h-24 w-24 md:h-52 md:w-52"
						src={'/images/not-found/wheel.svg'}
						alt={'not found wheel rotate'}
					/>
					0
				</div>
				<p className="h3 mb-8">{t('errorMessage')}: {error.name}</p>
				<div className="flex flex-col tablet:flex-row gap-4">
					<button
						className="btn btn-accent bg-white border-green border-1 text-green h-fit px-8 py-2"
						onClick={() => reset()}>
						{t('reset')}
					</button>
				</div>
			</main>
		</>
	);
};
export default Error;
